<kion-title-bar
  project="LR"
  [title]="{title: 'search.results.headline' | translate: {query: query$ | async}, titleSize: component.titleSize}"
></kion-title-bar>
